export default __webpack_public_path__ + "static/media/icon_Folder_Open_.65055d39.svg";